import { Section, Link } from "@arp/react-ndbx";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import {
  TRACKIFY_EVENT,
  URLS,
  sendEmailModalContent,
} from "../../../config/const/enums";
import useTheme from "@mui/material/styles/useTheme";
import { trackifyPageChange } from "@allianz/tracking";

function EmailSentSuccess({ customerEmailAddress }) {
  const theme = useTheme();

  useEffect(() => {
    trackifyPageChange(TRACKIFY_EVENT.SEND_EMAIL_SUCCESS);
  }, []);

  return (
    <Section
      controlIdentifier="send-email-success"
      sx={{
        pl: { xs: 4, sm: 8 },
        pr: { xs: 4, sm: 8 },
        pt: { xs: 5, sm: 8 },
        mt: 0,
        mb: 0,
      }}
    >
      <CheckCircleRoundedIcon
        sx={{
          fontSize: 100,
          color: `${theme.palette.signal.Success500}`,
          mb: 2,
        }}
      />
      <Section sx={{ mt: 0, mb: 5 }}>
        <Typography variant="h3-bold">{sendEmailModalContent.DONE}</Typography>
      </Section>
      {/* <Section sx={{ mt: 0, mb: 5 }}>
        <Typography variant="label-large-regular">
          {sendEmailModalContent.QUOTE_SENT_TO}
        </Typography>
      </Section> */}
      <Section sx={{ mt: 0, mb: 2 }}>
        <Typography variant="p2-bold">
          {sendEmailModalContent.QUOTE_EMAILED}
        </Typography>
      </Section>
      <Section sx={{ mt: 0, mb: 6, wordWrap: "break-word" }}>
        <Typography variant="h5-bold">{customerEmailAddress}</Typography>
      </Section>
      <Section sx={{ mb: 2, mt: 0 }}>
        <Typography variant="p3">
          {sendEmailModalContent.QUOTE_RETRIEVE_NOTE}
        </Typography>
      </Section>
      <Section sx={{ mb: 2, mt: 0 }}>
        <Typography variant="p3">
          {sendEmailModalContent.QUOTE_CONTACT_US}
          <Link href={URLS.CONTACT_US_PHONE_URL}>
            {URLS.CONTACT_US_PHONE_NUMBER}
          </Link>
          .
        </Typography>
      </Section>
    </Section>
  );
}

export default EmailSentSuccess;
